import { render, staticRenderFns } from "./account-page.vue?vue&type=template&id=478ab9f0&scoped=true"
import script from "./account-page.vue?vue&type=script&lang=js"
export * from "./account-page.vue?vue&type=script&lang=js"
import style0 from "./account-page.vue?vue&type=style&index=0&id=478ab9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478ab9f0",
  null
  
)

export default component.exports